//---------------------------------------------------------------------------------------------
//---------------------------------------------------------------------------------------------
import { icsFormatter } from "../vendors/ics-formatter";
export function CalendarHelper() {
    var obj = {
        init: init,
        onClickAddToCalendar: onClickAddToCalendar,
        DownloadICS: DownloadICS
    };
    obj.submitUri = "/CalendarAppointment/DownloadICS/";
    obj.redirectUri = "/";
    return obj;

    function init() {
        var addToCalendar = '.add-to-calendar';
        obj.$addToCalendar = $(addToCalendar);

        if (obj.$addToCalendar) {
            obj.$addToCalendar.each(function () {
                $(this).on('click', obj.onClickAddToCalendar);
            });
        }
    }

    function onClickAddToCalendar() {
        var button = $(this);
        var date = button.data("calendar-datetime-start");
        var dateStop = button.data("calendar-datetime-stop");
        var title = button.data("calendar-title");
        var description = button.data("calendar-description");
        var location = button.data("calendar-location");

        if (window.patternLibrary) { // set in the sevice request page but only in the pattern library
            var icsHelper = icsFormatter();
            var begin = new Date(date);
            var end;
            if (dateStop && dateStop.length > 0) {
                end = new Date(dateStop);
            }
            else {
                end = new Date(begin)
                end.setHours(end.getHours() + 4); // default to 4 hour
            }
            icsHelper.addEvent(title, description, location, begin.toUTCString(), end.toUTCString());
            icsHelper.download('Shea Homes Appointment');
        }
        else {
            var begin = new Date(date);
            var end;
            if (dateStop && dateStop.length > 0) {
                end = new Date(dateStop);
            }
            else {
                end = new Date(begin)
                end.setHours(end.getHours() + 4); // default to 4 hour
            }
            var postData = {
                "EventStartTime": formatDate(begin),
                "EventEndTime": formatDate(end),
                "EventTitle": title,
                "EventDescription": description,
                "EventLocation": location
            };
            DownloadICS(postData).then(function (response) {
                let blobData = new Blob([response], { type: "text/plain" });
                obj.url = window.URL.createObjectURL(blobData);
                saveFile('shea-homes-appointment.ics', obj.url);
            }, function (rspErr) {
                // error downloading ICS file
                window.location.href = obj.redirectUri;
            });
        }
    };

    function formatDate(d) {
        d = new Date(d);
        var month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = '' + d.getFullYear(),
            hours = '' + d.getHours(),
            minutes = '' + d.getMinutes(),
            seconds = '' + d.getSeconds();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        if (hours.length < 2) hours = '0' + hours;
        if (minutes.length < 2) minutes = '0' + minutes;
        if (seconds.length < 2) seconds = '0' + seconds;

        return [year, month, day].join('-') + "T" + [hours, minutes, seconds].join(':');
    }

    //-------------------------------------------------------------------------------------------------
    // POST to Kentico to get ICS
    //-------------------------------------------------------------------------------------------------
    function DownloadICS(postData) {
        return new Promise(function (resolve, reject) {
            try {
                if (window.patternLibrary) // set in the sevice request page but only in the pattern library
                {
                    setTimeout(function () {
                        if (resolve) resolve();
                    }, 500);
                    return;
                }
                $.ajax({
                    type: "POST",
                    url: obj.submitUri,
                    data: postData,
                    cache: false,
                    success: function (response) {
                        if (resolve) resolve(response);
                    },
                    error: function (request, textStatus, errorThrown) {
                        if (reject) reject("AJAX error: " + request.statusText);
                    }
                });
            }
            catch (err) {
                if (reject) reject("Error occurred on submition of the form:" + err);
            }
        });
    }

    function saveFile(fileName, urlFile) {
        let a = document.createElement("a");
        a.style = "display: none";
        document.body.appendChild(a);
        a.href = urlFile;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(obj.url);
        a.remove();
    }
};
